import {Component, HostListener} from '@angular/core';
import {Observable, take} from "rxjs";
import {ConfigService} from "../services/config.service";
import {TitleService} from "../services/title.service";
import {Meta} from "@angular/platform-browser";
import {ChatService} from "../services/chat.service";
import {TrackingHelperService} from "../services/tracking-helper.service";
import {LanguageService} from "../services/language.service";
// import {TawkService} from "../services/tawk.service";
import {ChatwootService} from "../services/chatwoot.service";
import {GameService} from "../services/game.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent {

  // title = 'rivalFrontend';

  brandName:string;
  chatSystem:string;

  isChatToggled$: Observable<boolean>;
  //we are on play/gameId iframe so we dont need the chatbutton
  isChatBtnShown$: Observable<boolean>;

  hasChatwoot: boolean;



  constructor(
    private configs: ConfigService,
    private titleService: TitleService,
    private metaService: Meta,
    private chatService: ChatService,
    private trackingService: TrackingHelperService,
    private langService: LanguageService,
    // public TawkMessengerAngular: TawkMessengerAngular
    // private tawkService: TawkService,
    private chatwootService: ChatwootService,
    private gameService: GameService,
    private router: Router

  ) {
    this.brandName = this.configs.brandName;
    this.chatSystem = this.configs.chatSystem;

    this.hasChatwoot = !!this.configs.chatwoot_brandWebsiteToken;

    // this.titleService.setTitle( this.brandName + " Online Casino"); //not needed here as se set title in components

    this.metaService.addTags([
      {name: 'description', content: this.configs.metaDesc},
      {name: 'author', content: this.brandName},
      {name: 'keywords', content: 'online casino, slots, blackjack, live dealer game, table game, gambling bonuses, poker, free spins, real money, cash rewards, big jackpot, deposit bonus, secure transaction, fast payout, bitcoin payment'}
    ])
    this.langService.initializeLanguage();

    this.isChatToggled$ = this.chatService.isChatToggled();
    this.isChatBtnShown$ = this.chatService.isChatBtnShown();

    //tracking and analytics
    this.trackingService.setCookiesFromQueryParams();


  }

  ngOnInit(){
    // //todo implement tawk messenger - this throws dependency error
    // if (this.chatSystem === 'tawk'){
    //   // this.tawkService.SetChatVisibility(true); //todo hide it from the beginning
    //   //   this.TawkMessengerAngular.init({
    // //     propertyId: '6696c9e7becc2fed69266443',
    // //     widgetId: '1i2ug9cme'
    // //   });
    // }

    if(this.hasChatwoot){
      this.chatwootService.loadChatwoot();
      //hide chatButton in html with this.hasChatwoot -> app-chat position to the left
    }


  }


  @HostListener('window:message', ['$event'])
  onMessage(event: any) {
    if (event.origin.includes("casinocontroller")){
      // console.log('Received message:', event.data); //TODO comment this out for publishing

      this.trackingService.trackEventFromMessage(event)

      /** when game/registration is loaded, push previous page into window.history to be able to navigate back by clicking once on browser's BACK button (but this will load the returnUrl pages if the user refreshes the page)
       if (event.data.action && event.data.action === "GAMES_START_GAME"){
       // this.location.replaceState(`/details/${event.data.id}`);
       // this.location.go(`/details/${event.data.id}`);

       //no-angular version
       // let returnUrl = window.location.href.split("/play")[0];
       // window.history.pushState("", "Game", `${returnUrl}/details/${event.data.id}`)
       // window.history.pushState("", "Game", `${returnUrl}/details/${event.data.id}`)

       //I dont remember what it was  --> hijack launching game:
       if (!window.location.href.includes("legacy")) {
       // this.router.navigate(['play', `${event.data.id}`])
       }
       }*/


      /** fix the game stays active in background problem until a better messaging solution exists
       * `<script>
       * window.addEventListener("message", function(evt) {
       *   var gameId_to_url = {
       *     2531: 'https://true-fortune.com/play/blazin--buffalo-extreme---hold---win',
       *   };
       *   if (evt.data.action == 'GAMES_START_GAME') {
       *      document.location.href = gameId_to_url[evt.data.id];
       *   }
       * });
       * </script>`
       *
       * */
      if (event.data.action && event.data.action === "GAMES_START_GAME"){
        this.gameService.getGames().pipe(take(1)).subscribe(games=>{
          const game = games.getById(event.data.id);
          if(!game) return;

          const slug = game.slug
          this.router.navigate(['play', slug])
        })
      }

    }
  }




  openChat() {
    this.chatService.toggleChat(true);
  }


  // public throwTestError(): void {
  //   throw new Error("Sentry Test Error");
  // }


}
